/**
 * 价格-转化率洞察API服务
 * 职责: 提供价格弹性、最优价格区间、价格劣势分析API
 * 限制: <100行
 */

import axios from 'axios';

const API_BASE_URL = 'http://localhost:8000/api';

export interface PriceElasticityResult {
  period_id: number;
  period_label: string;
  summary: {
    total_keywords: number;
    high_sensitivity: number;
    medium_sensitivity: number;
    low_sensitivity: number;
  };
  keywords: Array<{
    search_query: string;
    search_volume: number;
    asin_price: number;
    market_price: number;
    asin_cvr: number;
    market_cvr: number;
    price_elasticity: number;
    sensitivity_level: string;
  }>;
}

export interface KeywordCrossPeriodData {
  avg_median_price: number;
  avg_market_cvr: number;
  period_count: number;
  periods: Array<{
    period_label: string;
    median_price: number;
    market_cvr: number;
  }>;
}

export interface KeywordDetail {
  search_query: string;
  search_volume: number;
  current_period: {
    median_price: number;
    market_cvr: number;
    clicks: number;
    purchases: number;
  };
  cross_period_summary: KeywordCrossPeriodData;
}

export interface OptimalPriceRangeResult {
  period_id: number;
  period_label: string;
  asin_current_price: number;
  recommended_range: string;
  keyword_search?: string;
  price_ranges: Array<{
    price_range: string;
    keyword_count: number;
    total_search_volume: number;
    avg_market_cvr: number;
    keywords: KeywordDetail[];
  }>;
}

export interface PriceDisadvantageResult {
  period_id: number;
  period_label: string;
  summary: {
    total_keywords: number;
    disadvantage_count: number;
    advantage_count: number;
    neutral_count: number;
  };
  disadvantage_keywords: Array<{
    search_query: string;
    search_volume: number;
    asin_price: number;
    market_price: number;
    asin_cvr: number;
    market_cvr: number;
    cvr_diff_rate: number;
    opportunity: string;
  }>;
  advantage_keywords: Array<{
    search_query: string;
    search_volume: number;
    asin_price: number;
    market_price: number;
    asin_cvr: number;
    market_cvr: number;
    cvr_diff_rate: number;
  }>;
}

export const priceCVRAPI = {
  /**
   * 获取价格弹性分析
   */
  getPriceElasticity: (periodId: number) => {
    return axios.get<PriceElasticityResult>(
      `${API_BASE_URL}/price-cvr-analysis/price-elasticity/`,
      { params: { period_id: periodId } }
    );
  },

  /**
   * 获取最优价格区间
   */
  getOptimalPriceRange: (periodId: number, keywordSearch?: string) => {
    return axios.get<OptimalPriceRangeResult>(
      `${API_BASE_URL}/price-cvr-analysis/optimal-price-range/`,
      { params: { period_id: periodId, keyword_search: keywordSearch || '' } }
    );
  },

  /**
   * 获取价格劣势关键词
   */
  getPriceDisadvantage: (periodId: number) => {
    return axios.get<PriceDisadvantageResult>(
      `${API_BASE_URL}/price-cvr-analysis/price-disadvantage/`,
      { params: { period_id: periodId } }
    );
  },
};

